import Summary from './summary';

export default Summary;